import { Link } from "react-router-dom";
import Logo from "@/components/brand/Logo";

export default function BillingCancelPage() {
  return (
    <div className="dark-marketing grain min-h-screen flex items-center justify-center px-6" data-testid="billing-cancel-page">
      <div className="absolute top-6 left-6">
        <Link to="/"><Logo variant="light" /></Link>
      </div>
      <div className="w-full max-w-lg glass rounded-sm p-8 text-center">
        <p className="editorial-overline">Checkout canceled</p>
        <h1 className="font-serif text-3xl text-ivory-50 mt-3">No charge was made.</h1>
        <p className="text-sm text-ivory-200/70 mt-3">
          You closed the checkout before completing payment. No worries — nothing has been billed.
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/pricing" className="px-6 py-3 bg-gold-500 hover:bg-gold-400 text-navy-900 font-semibold rounded-sm text-sm">
            Back to pricing
          </Link>
          <Link to="/dashboard" className="px-6 py-3 border border-ivory-200/20 hover:border-gold-500 text-ivory-50 rounded-sm text-sm">
            Continue to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
